import React, { useEffect, useState, useRef } from "react";
import { Button, Row, Col, Form, Alert, Modal } from "react-bootstrap";
import FormControlLabel from "@mui/material/FormControlLabel";
import Switch from "@mui/material/Switch";
import { Link, useHistory } from "react-router-dom";
import Select from "react-select";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import withStyles from "@mui/styles/withStyles";
import makeStyles from "@mui/styles/makeStyles";
import { lighten } from "@mui/material/styles";
import { Checkbox } from "@mui/material";
import TablePagination from "@mui/material/TablePagination";
import TableSortLabel from "@mui/material/TableSortLabel";
import PropTypes from "prop-types";
import Toolbar from "@mui/material/Toolbar";
import AppBar from "@mui/material/AppBar";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import { Grid, TextField } from "@mui/material";
import AADService from "../funcionesAuth.js";
import { Tooltip, List, ListItem, ListItemText } from "@material-ui/core";
import { HelpOutline } from "@material-ui/icons";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import ControlesProtegidos from "./ControlesProtegidos.js";
import GraficaCostos from "./GraficaCostos.js";
import { use } from "echarts";

function AlertDismissibleExample({ alerta }) {
  switch (alerta) {
    case 1:
      return <Alert variant="warning">Alerta</Alert>;
      break;
    case 2:
      return (
        <Alert variant="success">
          Guardó exitosamente la informacióm del Control
        </Alert>
      );
      break;
    case 3:
      return <Alert variant="danger"></Alert>;
      break;
    case 4:
      return (
        <Alert variant="warning">
          Error al enviar la información del Control
        </Alert>
      );
      break;
    case 5:
      return <Alert variant="danger">Error en el servidor</Alert>;
      break;
    case 6:
      return <Alert variant="danger">Faltan campos por llenar</Alert>;
      break;
    default:
      return <p></p>;
      break;
  }
}
const opcion_nivel_automatizacion = [
  { id: "1", nombre: "Manual" },
  { id: "2", nombre: "Semiautomático" },
  { id: "3", nombre: "Automático" },
];

const opcion_nivel_gestion = [
  { id: "1", nombre: "No existe" },
  { id: "2", nombre: "Inicial" },
  { id: "3", nombre: "Repetible" },
  { id: "4", nombre: "Definido" },
  { id: "5", nombre: "Administrado" },
  { id: "6", nombre: "Optimizado" },
];

const headCells = [
  { id: "idcontrol", numeric: false, disablePadding: false, label: "ID " },
  {
    id: "idcontrol_nist",
    numeric: false,
    disablePadding: false,
    label: "ID Estandar Nist",
  },
  {
    id: "nombre_control",
    numeric: false,
    disablePadding: false,
    label: "Nombre",
  },
];
const headCellsCompP = [
  { id: "id", numeric: false, disablePadding: false, label: "ID" },
  { id: "nombre", numeric: false, disablePadding: false, label: "Nombre" },
  {
    id: "descripcion",
    numeric: false,
    disablePadding: false,
    label: "Descripción",
  },
  {
    id: "UsuarioResponsableTI",
    numeric: false,
    disablePadding: false,
    label: "Responsable TI",
  },
  {
    id: "UsuarioResponsableNegocio",
    numeric: false,
    disablePadding: false,
    label: "Responsable Negocio",
  },
];
function descendingComparator(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

function getComparator(order, orderBy) {
  return order === "desc"
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}
const stylesSelect = {
  control: (base) => ({
    ...base,
    fontFamily: "Roboto",
  }),
  menu: (base) => ({
    ...base,
    fontFamily: "CIBFont Sans Regular",
  }),

  option: (provided, state) => ({
    ...provided,
    //color: state.isFocused ? 'white' : '#495057',
  }),
};
const useStylesModal = makeStyles((theme) => ({
  root: {
    width: "100%",
  },
  paper: {
    width: "100%",
    //marginBottom: theme.spacing(2),
  },
  table: {
    minWidth: 750,
  },
  visuallyHidden: {
    border: 0,
    clip: "rect(0 0 0 0)",
    height: 1,
    margin: -1,
    overflow: "hidden",
    padding: 0,
    position: "absolute",
    top: 20,
    width: 1,
  },
  container: {
    maxHeight: "40vh",
    minHeight: "40vh",
  },
}));
function EnhancedTableHeadCompP(props) {
  const {
    classes,
    onSelectAllClick,
    order,
    orderBy,
    numSelected,
    rowCount,
    onRequestSort,
  } = props;
  const createSortHandler = (property) => (event) => {
    onRequestSort(event, property);
  };
  return (
    <TableHead>
      <TableRow>
        <TableCell
          style={{ backgroundColor: "#2c2a29", color: "#ffffff" }}
        ></TableCell>
        {headCellsCompP.map((headCell) => (
          <TableCell
            key={headCell.id}
            align={headCell.numeric ? "right" : "left"}
            padding={headCell.disablePadding ? "none" : "default"}
            sortDirection={orderBy === headCellsCompP.id ? order : false}
            style={{ backgroundColor: "#2c2a29", color: "#ffffff" }}
          >
            <TableSortLabel
              active={orderBy === headCell.id}
              direction={orderBy === headCell.id ? order : "asc"}
              onClick={createSortHandler(headCell.id)}
              className="label"
            >
              {headCell.label}
              {orderBy === headCell.id ? (
                <span className={classes.visuallyHidden}>
                  {order === "desc" ? "sorted descending" : "sorted ascending"}
                </span>
              ) : null}
            </TableSortLabel>
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
}

function EnhancedTableHead(props) {
  const {
    classes,
    onSelectAllClick,
    order,
    orderBy,
    numSelected,
    rowCount,
    onRequestSort,
  } = props;
  const createSortHandler = (property) => (event) => {
    onRequestSort(event, property);
  };
  return (
    <TableHead>
      <TableRow>
        <TableCell
          padding="checkbox"
          style={{ backgroundColor: "#2c2a29", color: "#ffffff" }}
        >
          <Checkbox
            indeterminate={numSelected > 0 && numSelected < rowCount}
            checked={rowCount > 0 && numSelected === rowCount}
            onChange={onSelectAllClick}
            inputProps={{ "aria-label": "select all desserts" }}
          />
        </TableCell>
        {headCells.map((headCell) => (
          <TableCell
            key={headCell.id}
            align={headCell.numeric ? "right" : "left"}
            padding={headCell.disablePadding ? "none" : "default"}
            sortDirection={orderBy === headCell.id ? order : false}
            style={{ backgroundColor: "#2c2a29", color: "#ffffff" }}
          >
            <TableSortLabel
              active={orderBy === headCell.id}
              direction={orderBy === headCell.id ? order : "asc"}
              onClick={createSortHandler(headCell.id)}
              className="label"
            >
              {headCell.label}
              {orderBy === headCell.id ? (
                <span className={classes.visuallyHidden}>
                  {order === "desc" ? "sorted descending" : "sorted ascending"}
                </span>
              ) : null}
            </TableSortLabel>
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
}

EnhancedTableHead.propTypes = {
  classes: PropTypes.object.isRequired,
  numSelected: PropTypes.number.isRequired,
  onRequestSort: PropTypes.func.isRequired,
  onSelectAllClick: PropTypes.func.isRequired,
  order: PropTypes.oneOf(["asc", "desc"]).isRequired,
  orderBy: PropTypes.string.isRequired,
  rowCount: PropTypes.number.isRequired,
};
EnhancedTableHeadCompP.propTypes = {
  classes: PropTypes.object.isRequired,
  numSelected: PropTypes.number.isRequired,
  onRequestSort: PropTypes.func.isRequired,
  onSelectAllClick: PropTypes.func.isRequired,
  order: PropTypes.oneOf(["asc", "desc"]).isRequired,
  orderBy: PropTypes.string.isRequired,
  rowCount: PropTypes.number.isRequired,
};
function stableSort(array, comparator) {
  const stabilizedThis = array.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) return order;
    return a[1] - b[1];
  });
  return stabilizedThis.map((el) => el[0]);
}

function EditarImplementadores() {
  const AzureADService = new AADService();
  const token = AzureADService.getToken();
  const [estadoPOST, setEstadoPost] = React.useState(0);
  const [companiaDat, setCompaniaDat] = React.useState([]);
  const [companiaDatOption, setCompaniaDatOption] = React.useState([]);
  const [implementador, setImplementador] = React.useState([]);
  const [implementadorXControl, setImplementadorXControl] = React.useState([]);
  const [selectedValueCompania, setSelectedValueCompania] = useState(null);
  const [checkedEstado, setCheckedEstado] = useState(true);
  const [stateEstado, setStateEstado] = useState("");
  const [checkedMapeadoControles, setCheckedMapeadoControles] = useState(true);
  const [stateMapeadoControles, setStateMapeadoControles] = useState("");
  const [validated, setValidated] = useState(false);
  const [modalShow, setModalShow] = React.useState(false);
  const [direccion, setDireccion] = React.useState(false);
  const [rowsP, setRowsP] = React.useState([]);
  const [rows, setRows] = React.useState([]);
  const [controles, setControles] = useState([]);
  const [idrolUser, setIdrolUser] = useState(
    parseInt(localStorage.getItem("rolusuario"))
  );
  const [controlSelected, setControlSelected] = React.useState([]);
  const [categoriaControl, setCategoriaControl] = useState(null);
  const [tipoControl, setTipoControl] = useState(null);
  const [capaControl, setCapaControl] = useState(null);
  const [dataZeroTrust, setDataZeroTrust] = useState([]);
  const [dataDominio, setDataDominio] = useState([]);
  const [dataTipoUsuario, setDataTipoUsuario] = useState([]);
  const [datAreaResponsable, setdatAreaResponsable] = useState([]);
  const [capaControlTemp, setCapaControlTemp] = useState([]);
  const [valcategoriaControl, setvalCategoriaControl] = useState("");
  const [valTipoControl, setvalTipoControl] = useState();
  const [valcapaControl, setvalCapaControl] = useState([]);
  const [codigoActivo, setCodigoActivo] = React.useState("");
  const [canalT, setCanalT] = React.useState("");
  const [despliegue, setvaluedesp] = useState([]);
  const [DataDespliegue, setDataDespliegue] = React.useState([]);
  const [DataCanal, setDataCanal] = React.useState([]);
  const [tipoComp2, setTipoComp2] = React.useState([]);
  const [activeTab, setActiveTab] = useState(0);
  const [modalShowCompP, setModalShowCompP] = React.useState(false);
  const [modalCompo, setModalCompo] = useState([]);
  const [rowsc, setRowsC] = React.useState([]);
  const [nivelAutomatizacion, setNivelAutomatizacion] = useState("");
  const [companiaSelect, setCompaniaSelect] = useState(null);
  const [valuecompnusada, setvaluecompnusada] = useState([]);
  const [listaAmenaza, setListaAmenaza] = useState([]);
  const [valAmenaza, setvalAmenaza] = useState([]);
  const [sections, setSections] = useState([]);
  const [activeSection, setActiveSection] = useState(null);
  const [selectedCheckboxes, setSelectedCheckboxes] = useState([]);
  const [valueNombre, setValueNombre] = React.useState([]);
  const [valueFabricante, setValueFabricante] = React.useState("");
  const [valueDescripcion, setValueDescripcion] = React.useState("");
  const [valueZero, setValueZero] = React.useState([]);
  const [valueDominio, setValueDominio] = React.useState([]);
  const [valueCodigo, setValueCodigo] = React.useState("");
  const [valueServicio, setValueServicio] = React.useState([]);
  const [valueCapacidad, setValueCapacidad] = React.useState("");
  const [valueTipoUsuario, setValueTipoUsuario] = React.useState([]);
  const [valueAreaResponsable, setValueAreaResponsable] = React.useState([]);
  const [valueDocumentacion, setValueDocumentacion] = React.useState("");
  const [valueEficacia, setValueEficacia] = React.useState(1);
  const [valuePruebaTecnica, setValuePruebaTecnica] = React.useState(0);
  const [valueDisenoControl, setValueDisenoControl] = React.useState(0);
  const [valueDisenoControl2, setValueDisenoControl2] = React.useState(0);
  const [errorEO, setErrorEO] = useState(false);
  const [componentesSelected, setComponentesSelected] = React.useState([]);
  const ejecutadoRef = useRef(false);
  const mapValCapaControl = valcapaControl.map((option) => option.label);
  const labelCapaControl = mapValCapaControl.join(",");
  const mapTipoDespliegue = despliegue.map((option) => option.label);
  const labelTipoDespliegue = mapTipoDespliegue.join(",");
  const mapCompUsada = valuecompnusada.map((option) => option.label);
  const labelCompUsada = mapCompUsada.join(",");
  const mapAmenaza = valAmenaza.map((option) => option.value);
  const labelAmenaza = mapAmenaza.join(",");
  //Costo-Beneficio
  const [riesgosMitiga, setRiesgosMitiga] = useState();
  const [licencias, setLicencias] = useState("");
  const [periodLicencias, setPeriodLicencias] = useState("Anual");
  const [implementacion, setImplementacion] = useState("");
  const [periodImplementacion, setPeriodImplementacion] = useState("Anual");
  const [mantenimiento, setMantenimiento] = useState("");
  const [periodMantenimiento, setPeriodMantenimiento] = useState("Anual");
  const [actualizacion, setActualizacion] = useState("");
  const [periodActualizacion, setPeriodActualizacion] = useState("Anual");
  const [soporte, setSoporte] = useState("");
  const [periodSoporte, setPeriodSoporte] = useState("Anual");
  const [consultoria, setConsultoria] = useState("");
  const [periodConsultoria, setPeriodConsultoria] = useState("Anual");
  const [personal, setPersonal] = useState("");
  const [periodPersonal, setPeriodPersonal] = useState("Anual");
  const [idCostoBeneficio, setIdCostoBeneficio] = useState(0);
  const [moneda, setMoneda] = useState("USD");
  const [costosTotales, setCostosTotales] = useState("");
  const [amenazaAnalizar, setAmenazaAnalizar] = useState([]);
  const [selectedAmenazas, setSelectedAmenazas] = useState([]);
  const [exposicion, setExposicion] = useState("");
  const [rosi, setRosi] = useState("");
  const [resumenData, setResumenData] = useState({});

  const StyledTableCell = withStyles((theme) => ({
    head: {
      backgroundColor: "#2c2a29",

      color: "white",
    },
  }))(TableCell);
  const StyledTableRow = withStyles((theme) => ({
    root: {
      backgroundColor: "#f4f4f4",
    },
  }))(TableRow);
  const clamp01 = (n) => Math.min(1, Math.max(0, Number(n) || 0));
  const valueToColor = (v) => {
    const val = clamp01(v);
    const hue = val * 120;
    const saturation = 90;
    const lightness = 45;
    return `hsl(${hue}deg ${saturation}% ${lightness}%)`;
  };
  const safeVal = clamp01(valueEficacia);
  const colorEficacia = valueToColor(safeVal);

  const limpiarCampos = () => {
    setRiesgosMitiga([]);
    setAmenazaAnalizar([]);
    setMoneda("USD");
    setLicencias("");
    setPeriodLicencias("Anual");
    setImplementacion("");
    setPeriodImplementacion("Anual");
    setMantenimiento("");
    setPeriodMantenimiento("Anual");
    setActualizacion("");
    setPeriodActualizacion("Anual");
    setSoporte("");
    setPeriodSoporte("Anual");
    setConsultoria("");
    setPeriodConsultoria("Anual");
    setPersonal("");
    setPeriodPersonal("Anual");
    setCostosTotales("");
    setExposicion("");
    setRosi("");
  };
  
  const obtenerCostoBeneficio = async () => {
    try {
      const result = await fetch(
        `${process.env.REACT_APP_API_URL}maestro/rosi/${localStorage.getItem(
          "idimplementador"
        )}/${localStorage.getItem("idcompania")}/`,
        {
          method: "GET",
          headers: {
            Accept: "application/json",
            //Authorization: "Bearer " + token,
          },
        }
      );

      const dataCostoBeneficio = await result.json();

      if (result.ok && dataCostoBeneficio) {
        console.log("Datos de costo beneficio:", dataCostoBeneficio);

        setRiesgosMitiga(
          dataCostoBeneficio.atributosCID?.map((item) => ({
            label: item,
            value: item,
          })) || []
        );

        const opciones = dataCostoBeneficio.amenazas.map((item) => ({
          label: item.evento_amenaza,
          value: item.idamenaza,
        }));

        setSelectedAmenazas(opciones);

        const cb = dataCostoBeneficio.costo_beneficio?.[0] || {};

        const setters = {
          idcosto_beneficio: setIdCostoBeneficio,
          moneda: setMoneda,
          licencias: setLicencias,
          perio_licencias: setPeriodLicencias,
          implementacion: setImplementacion,
          perio_implementacion: setPeriodImplementacion,
          mantenimiento: setMantenimiento,
          perio_mantenimiento: setPeriodMantenimiento,
          actualizacion: setActualizacion,
          perio_actualizacion: setPeriodActualizacion,
          adminsoporte: setSoporte,
          perio_adminsoporte: setPeriodSoporte,
          consultoria: setConsultoria,
          perio_consultoria: setPeriodConsultoria,
          personal: setPersonal,
          perio_personal: setPeriodPersonal,
          costo_total: setCostosTotales,
          exposicion: setExposicion,
          rosi: setRosi,
        };

        Object.entries(setters).forEach(([key, setter]) => {
          setter(cb[key] ?? (key.startsWith("perio_") ? "Anual" : ""));
        });
      } else {
        console.warn("No hay datos de costo beneficio");
        limpiarCampos();
      }
    } catch (error) {
      console.error("Error al obtener costo beneficio:", error);
      limpiarCampos();
    }
  };

  useEffect(() => {
    const obtenerListaAmenaza = async () => {
      const result = await fetch(
        process.env.REACT_APP_API_URL + "maestro/amenazas/0",
        {
          method: "GET",
          headers: {
            Accept: "application/json",
            Authorization: "Bearer " + token,
          },
        }
      );
      let data = await result.json();
      const mapListaAmenaza = data.map((option) => ({
        value: option.idamenaza,
        label: option.evento_amenaza,
      }));
      setListaAmenaza(mapListaAmenaza);
    };
    const obtenerComponentes = async () => {
      const result = await fetch(
        process.env.REACT_APP_API_URL +
        "allcomponents/" +
        localStorage.getItem("idcompania") +
        "/1/"+ localStorage.getItem("idusuario") + "/",
        {
          method: "GET",
          headers: {
            Accept: "application/json",
            Authorization: "Bearer " + token,
          },
        }
      );
      let datComponentes = await result.json();
      setModalCompo(datComponentes);
    };
    const obtenerTipoComp = async () => {
      const result = await fetch(
        process.env.REACT_APP_API_URL + "general/tipoactivo/",
        {
          method: "GET",
          headers: {
            Accept: "application/json",
            Authorization: "Bearer " + token,
          },
        }
      );
      let data = await result.json();
      setTipoComp2(data);
    };
    const obtenerTipoDespliegue = async () => {
      const result = await fetch(
        process.env.REACT_APP_API_URL +
        "general/parametrosGeneralesxGrupoxParametro/Componentes/Tipo_Despliegue/",
        {
          method: "GET",
          headers: {
            Accept: "application/json",
            Authorization: "Bearer " + token,
          },
        }
      );
      let datTipoDespliegue = await result.json();
      if (result.status === 200) {
        setDataDespliegue(datTipoDespliegue);
      }
      else {
        setDataDespliegue([]);
      }
    };
    const obtenerTipoCanal = async () => {
      const result = await fetch(
        process.env.REACT_APP_API_URL +
        "general/parametrosGeneralesxGrupoxParametro/Componentes/Tipo_Canal/",
        {
          method: "GET",
          headers: {
            Accept: "application/json",
            Authorization: "Bearer " + token,
          },
        }
      );
      let datTipoCanal = await result.json();
      if (result.status === 200) {
        setDataCanal(datTipoCanal);
      }
      else {
        setDataCanal([]);
      }
    };
    const obtenerCategoriaControl = async () => {
      const result = await fetch(
        process.env.REACT_APP_API_URL +
        "general/parametrosGeneralesxGrupoxParametro/Implementadores/Categoria_Control/",
        {
          method: "GET",
          headers: {
            Accept: "application/json",
            Authorization: "Bearer " + token,
          },
        }
      );
      let datCategoria = await result.json();
      if (result.status === 200) {
        const mapCategoriaControl = datCategoria.map((option) => ({
          value: option.idparametrosgenerales,
          label: option.vlrmetrica,
        }));
        setCategoriaControl(mapCategoriaControl);
      }
      else {
        setCategoriaControl([]);
      }
    };
    const obtenerTipoControl = async () => {
      const result = await fetch(
        process.env.REACT_APP_API_URL +
        "general/parametrosGeneralesxGrupoxParametro/Implementadores/Tipo_Control/",
        {
          method: "GET",
          headers: {
            Accept: "application/json",
            Authorization: "Bearer " + token,
          },
        }
      );
      let datTipoControl = await result.json();
      if (result.status === 200) {

        const mapTipoControl = datTipoControl.map((option) => ({
          value: option.idparametrosgenerales,
          label: option.vlrmetrica,
        }));
        setTipoControl(mapTipoControl);

      }
      else {
        setTipoControl([]);
      }

    };
    const obtenercapaControl = async () => {
      const result = await fetch(
        process.env.REACT_APP_API_URL +
        "general/parametrosGeneralesxGrupoxParametro/Implementadores/Capa_Control/",
        {
          method: "GET",
          headers: {
            Accept: "application/json",
            Authorization: "Bearer " + token,
          },
        }
      );
      let datCapaControl = await result.json();
      if (result.status === 200) {

        const mapCapaControl = datCapaControl.map((option) => ({
          value: option.idparametrosgenerales,
          label: option.vlrmetrica,
        }));
        setCapaControl(mapCapaControl);
      } else {
        setCapaControl([]);
      }
    };
    const obtenerImplementador = async () => {
      const result = await fetch(
        process.env.REACT_APP_API_URL +
        "maestro/implementadores/" +
        localStorage.getItem("idimplementador") +
        "/" +
        localStorage.getItem("idcompania") +
        "/",
        {
          method: "GET",
          headers: {
            Accept: "application/json",
            Authorization: "Bearer " + token,
          },
        }
      );
      let datProcesos = await result.json();

      const data = await fetch(
        process.env.REACT_APP_API_URL + "general/compania/",
        {
          method: "GET",
          headers: {
            Accept: "application/json",
            Authorization: "Bearer " + token,
          },
        }
      );
      let datCompania = await data.json();
      let companiaSelect = [];
      companiaSelect = datCompania.map(
        ({ idcompania: value, compania: label }) => ({
          value,
          label,
        })
      );
      setCompaniaDat(companiaSelect);

      let nombrecompania = datCompania
        .filter(({ idcompania }) => idcompania === datProcesos.idcompania)
        .map(({ compania }) => compania)
        .pop();

      if (datProcesos != null && datProcesos.idcompania !== null) {
        setSelectedValueCompania({
          value: datProcesos.idcompania,
          label: nombrecompania,
        });
        setCompaniaSelect({
          idcompania: datProcesos.idcompania,
          compania: nombrecompania,
        });
      }
      if (datProcesos && datProcesos.companias_usan) {
        const companiasUsanArray = datProcesos.companias_usan.split(",");
        const companiasUsanObjArray = [];
        companiasUsanArray.forEach((item) => {
          companiasUsanObjArray.push({
            value: item,
            label: item,
          });
        });
        setvaluecompnusada(companiasUsanObjArray);
      }

      if (datProcesos && datProcesos.nivel_automatizacion) {
        const nivelAutomatizacionEncontrado = opcion_nivel_automatizacion.find(
          (opcion) => opcion.nombre === datProcesos.nivel_automatizacion
        );

        if (nivelAutomatizacionEncontrado) {
          setNivelAutomatizacion({
            id: nivelAutomatizacionEncontrado.id,
            nombre: nivelAutomatizacionEncontrado.nombre,
          });
        }
      }
      if (datProcesos && datProcesos.tipo_control) {
        setvalTipoControl({
          label: datProcesos.tipo_control,
          value: datProcesos.tipo_control,
        });
      }
      if (datProcesos && datProcesos.tipo_despliegue) {
        const tipoDesplieguearrayArray = datProcesos.tipo_despliegue.split(",");
        const tipoDespliegueObjArray = [];
        tipoDesplieguearrayArray.forEach((item) => {
          tipoDespliegueObjArray.push({
            value: item,
            label: item,
          });
        });
        setvaluedesp(tipoDespliegueObjArray);
      }
      if (datProcesos && datProcesos.categoria_control) {
        setvalCategoriaControl({
          label: datProcesos.categoria_control,
          value: datProcesos.categoria_control,
        });
      }
      if (datProcesos && datProcesos.capa_control) {
        const capaarrayArray = datProcesos.capa_control.split(",");
        const capaObjArray = [];
        capaarrayArray.forEach((item) => {
          capaObjArray.push({
            value: item,
            label: item,
          });
        });
        setvalCapaControl(capaObjArray);
      }
      if (datProcesos && datProcesos.amenazas) {
        const amenazaarrayArray = datProcesos.amenazas;
        const amenazaObjArray = [];
        amenazaarrayArray.forEach((item) => {
          amenazaObjArray.push({
            value: item.idamenaza,
            label: item.evento_amenaza,
          });
        });
        setvalAmenaza(amenazaObjArray);
        setAmenazaAnalizar(amenazaObjArray);
      }
      if (datProcesos && datProcesos.zero_trust) {
        setValueZero({
          label: datProcesos.zero_trust,
          value: datProcesos.zero_trust,
        });
      }
      if (datProcesos && datProcesos.codigo) {
        const codigoParseValue = parseInt(datProcesos.codigo, 10);
        setValueCodigo(codigoParseValue);
      }
      if (datProcesos && datProcesos.servicio) {
        setValueServicio({
          label: datProcesos.servicio,
          value: datProcesos.servicio,
        });
      }
      if (datProcesos && datProcesos.capacidad) {
        setValueCapacidad({
          label: datProcesos.capacidad,
          value: datProcesos.capacidad,
        });
      }
      if (datProcesos && datProcesos.dominio) {
        setValueDominio({
          label: datProcesos.dominio,
          value: datProcesos.dominio,
        });
      }
      if (datProcesos && datProcesos.tipo_de_usuario) {
        setValueTipoUsuario({
          label: datProcesos.tipo_de_usuario,
          value: datProcesos.tipo_de_usuario,
        });
      }
      if (datProcesos && datProcesos.area_responsable) {
        setValueAreaResponsable({
          label: datProcesos.area_responsable,
          value: datProcesos.area_responsable,
        });
      }
      if (datProcesos && datProcesos.idtipo_activo) {
        if (datProcesos.idtipo_activo === 17) {
          setCodigoActivo({
            idtipo_activo: 17,
            codigogeneral: "COM",
            estado: true,
            tipo_activo: "Aplicativos",
          });
        } else if (datProcesos.idtipo_activo === 18) {
          setCodigoActivo({
            idtipo_activo: 18,
            codigogeneral: "COM",
            estado: true,
            tipo_activo: "Servidores",
          });
        } else if (datProcesos.idtipo_activo === 19) {
          setCodigoActivo({
            idtipo_activo: 19,
            codigogeneral: "COM",
            estado: true,
            tipo_activo: "Apis",
          });
        }
      } else {
        setCodigoActivo({
          idtipo_activo: "",
          codigogeneral: "",
          estado: true,
          tipo_activo: "Ninguno(No será considerado en las EROS)",
        });
      }
      if (datProcesos && datProcesos.tipo_canal) {
        setCanalT({
          vlrmetrica: datProcesos.tipo_canal,
        });
      }
      if (datProcesos && datProcesos.nombre) {
        setValueNombre(datProcesos.nombre);
      }
      if (datProcesos && datProcesos.fabricante) {
        setValueFabricante(datProcesos.fabricante);
      }
      if (datProcesos && datProcesos.descripcion) {
        setValueDescripcion(datProcesos.descripcion);
      }
      console.log("DATOS DE PRUEBA TECNICA", datProcesos.pruebatecnica);
      if (datProcesos && datProcesos.pruebatecnica) {
        console.log("HOLA", datProcesos.pruebatecnica);
        setValuePruebaTecnica(datProcesos.pruebatecnica);
      }
      if (datProcesos && datProcesos.eficaciaoperativa) {
        setValueEficacia(datProcesos.eficaciaoperativa);
      }
      if (datProcesos && datProcesos.efectividad) {
        setValueDisenoControl(datProcesos.efectividad);
        setValueDisenoControl2(datProcesos.efectividad);
      }
      if (datProcesos && datProcesos.documentacion) {
        setValueDocumentacion(datProcesos.documentacion);
      }
      if (datProcesos && datProcesos.niveles) {
        const nivelesArray = datProcesos.niveles;
        const nivelesObjArray = [];
        nivelesArray.forEach((item) => {
          nivelesObjArray.push(item.idparametrosgenerales);
        });
        setSelectedCheckboxes(nivelesObjArray);
      }
      if (datProcesos.estado === true) {
        setStateEstado("Activo");
        setCheckedEstado(true);
      } else {
        setStateEstado("Inactivo");
        setCheckedEstado(false);
      }

      if (datProcesos.mapeado_en_controles === 1) {
        setStateMapeadoControles("Si");
        setCheckedMapeadoControles(true);
      } else {
        setStateMapeadoControles("No");
        setCheckedMapeadoControles(false);
      }
      setImplementador(datProcesos);

      if (datProcesos && datProcesos.activo) {
        setRowsC(datProcesos.activo);
      }
    };

    const obtenerImplementadorXControl = async () => {
      const result = await fetch(
        process.env.REACT_APP_API_URL +
        "maestro/implementador_por_control/" +
        localStorage.getItem("idimplementador") +
        "/",
        {
          method: "GET",
          headers: {
            Accept: "application/json",
            Authorization: "Bearer " + token,
          },
        }
      );
      let dataImplementadorControl = await result.json();
      setImplementadorXControl(dataImplementadorControl);
      const newSelecteds = dataImplementadorControl.map((n) => n.idcontrol);
      setControlSelected(newSelecteds);
    };
    const obtenerCompañias = async () => {
      const result = await fetch(
        process.env.REACT_APP_API_URL + "general/compania/",
        {
          method: "GET",
          headers: {
            Accept: "application/json",
            Authorization: "Bearer " + token,
          },
        }
      );
      let datCompania = await result.json();
      setCompaniaDatOption(datCompania);
    };
    const fetchdata = async (rol) => {
      const result = await fetch(
        process.env.REACT_APP_API_URL + "maestro/controles/0/",
        {
          method: "GET",
          headers: {
            Accept: "application/json",
            Authorization: "Bearer " + token,
          },
        }
      );
      let data = await result.json();
      setControles(data);
    };
    const obtenerZeroTrust = async () => {
      const result = await fetch(
        process.env.REACT_APP_API_URL +
        "general/parametrosGeneralesxGrupoxParametro/Implementadores/ZeroTrust/",
        {
          method: "GET",
          headers: {
            Accept: "application/json",
            Authorization: "Bearer " + token,
          },
        }
      );
      let datZeroTrust = await result.json();
      if (result.status === 200) {
        const mapZeroTrust = datZeroTrust.map((option) => ({
          value: option.idparametrosgenerales,
          label: option.vlrmetrica,
        }));
        setDataZeroTrust(mapZeroTrust);
      }
      else {
        setDataZeroTrust([]);
      }
    };
    const obtenerDominio = async () => {
      const result = await fetch(
        process.env.REACT_APP_API_URL +
        "general/parametrosGeneralesxGrupoxParametro/Implementadores/Dominio/",
        {
          method: "GET",
          headers: {
            Accept: "application/json",
            Authorization: "Bearer " + token,
          },
        }
      );
      let datDominio = await result.json();
      if (result.status === 200) {
        const mapDominio = datDominio.map((option) => ({
          value: option.idparametrosgenerales,
          label: option.vlrmetrica,
        }));
        setDataDominio(mapDominio);
      }
      else {
        setDataDominio([]);
      }
    };
    const obtenerTipoUsuario = async () => {
      const result = await fetch(
        process.env.REACT_APP_API_URL +
        "general/parametrosGeneralesxGrupoxParametro/Implementadores/Tipo_Usuario/",
        {
          method: "GET",
          headers: {
            Accept: "application/json",
            Authorization: "Bearer " + token,
          },
        }
      );
      let datTipoUsuario = await result.json();
      if (result.status === 200) {
        const mapTipoUsuario = datTipoUsuario.map((option) => ({
          value: option.idparametrosgenerales,
          label: option.vlrmetrica,
        }));
        setDataTipoUsuario(mapTipoUsuario);
      }
      else {
        setDataTipoUsuario([]);
      }
    };
    const obtenerAreaResponsable = async () => {
      const result = await fetch(
        process.env.REACT_APP_API_URL +
        "general/parametrosGeneralesxGrupoxParametro/Implementadores/Area_Responsable/",
        {
          method: "GET",
          headers: {
            Accept: "application/json",
            Authorization: "Bearer " + token,
          },
        }
      );
      let datAreaResponsable = await result.json();
      if (result.status === 200) {
        const mapAreaResponsable = datAreaResponsable.map((option) => ({
          value: option.idparametrosgenerales,
          label: option.vlrmetrica,
        }));
        setdatAreaResponsable(mapAreaResponsable);
      }
      else {
        setdatAreaResponsable([]);
      }
    };
    const obtenerNiveles = async () => {
      const result = await fetch(
        process.env.REACT_APP_API_URL +
        "general/parametrosGeneralesxGrupoxParametro/Implementadores/Niveles/",
        {
          method: "GET",
          headers: {
            Accept: "application/json",
            Authorization: "Bearer " + token,
          },
        }
      );
      let datNiveles = await result.json();
      if (result.status === 200) {
        const seccionesMapeadas = mapearNiveles(datNiveles);
        setSections(seccionesMapeadas);
      }
      else {
        setSections([]);
      }
    };
    obtenerListaAmenaza();
    obtenerCompañias();
    obtenerComponentes();
    obtenerImplementadorXControl();
    obtenerImplementador();
    fetchdata();
    obtenerCategoriaControl();
    obtenerTipoControl();
    obtenercapaControl();
    obtenerTipoComp();
    obtenerTipoDespliegue();
    obtenerTipoCanal();
    obtenerZeroTrust();
    obtenerDominio();
    obtenerTipoUsuario();
    obtenerAreaResponsable();
    obtenerNiveles();
    obtenerCostoBeneficio();
  }, []);

  useEffect(() => {
    const calcularTotal = () => {
      const total =
        (Number(licencias) || 0) * factoresPeriodicidad[periodLicencias] +
        (Number(implementacion) || 0) *
        factoresPeriodicidad[periodImplementacion] +
        (Number(mantenimiento) || 0) *
        factoresPeriodicidad[periodMantenimiento] +
        (Number(actualizacion) || 0) *
        factoresPeriodicidad[periodActualizacion] +
        (Number(soporte) || 0) * factoresPeriodicidad[periodSoporte] +
        (Number(consultoria) || 0) * factoresPeriodicidad[periodConsultoria] +
        (Number(personal) || 0) * factoresPeriodicidad[periodPersonal];

      setCostosTotales(total);
      const rosiValue = (exposicion - total) / total || 0;
      setRosi(rosiValue.toFixed(2));
    };

    calcularTotal();
  }, [
    licencias,
    periodLicencias,
    implementacion,
    periodImplementacion,
    mantenimiento,
    periodMantenimiento,
    actualizacion,
    periodActualizacion,
    soporte,
    periodSoporte,
    consultoria,
    periodConsultoria,
    personal,
    periodPersonal,
    exposicion,
    costosTotales,
    selectedAmenazas,
  ]);

  const handleSaveCostoBeneficio = () => {

    const labelsAmenazas = selectedAmenazas.map((item) => item.label).join(",");

    //Asegurarse de que los campos obligatorios estén llenos
    if (
      moneda === "" ||
      licencias === "" ||
      periodLicencias === "" ||
      implementacion === "" ||
      periodImplementacion === "" ||
      mantenimiento === "" ||
      periodMantenimiento === "" ||
      actualizacion === "" ||
      periodActualizacion === "" ||
      soporte === "" ||
      periodSoporte === "" ||
      consultoria === "" ||
      periodConsultoria === "" ||
      personal === "" ||
      periodPersonal === "" ||
      labelsAmenazas === ""
    ) {
      setEstadoPost(6);
      return;
    } else {
      var datacb = JSON.stringify({
        idcosto_beneficio: idCostoBeneficio,
        idimplementador: localStorage.getItem("idimplementador"),
        moneda: moneda,
        licencias: licencias,
        perio_licencias: periodLicencias,
        implementacion: implementacion,
        perio_implementacion: periodImplementacion,
        mantenimiento: mantenimiento,
        perio_mantenimiento: periodMantenimiento,
        actualizacion: actualizacion,
        perio_actualizacion: periodActualizacion,
        adminsoporte: soporte,
        perio_adminsoporte: periodSoporte,
        consultoria: consultoria,
        perio_consultoria: periodConsultoria,
        personal: personal,
        perio_personal: periodPersonal,
        costo_total: costosTotales,
        exposicion: exposicion,
        rosi: rosi,
        amenazas: labelsAmenazas,
        idusuariocreacion: localStorage.getItem("idusuario"),
        idusuariomodificacion: localStorage.getItem("idusuario"),
        fechacreacion: new Date(),
        fechamodificacion: new Date(),
      });
      fetch(
        process.env.REACT_APP_API_URL +
        "maestro/rosi/" +
        localStorage.getItem("idimplementador") +
        "/" +
        localStorage.getItem("idcompania") +
        "/",
        {
          method: idCostoBeneficio && idCostoBeneficio !== 0 ? "PUT" : "POST",
          body: datacb,
          headers: {
            "Content-type": "application/json; charset=UTF-8",
            //Authorization: "Bearer " + token,
          },
        }
      )
        .then((data) =>
          data.json().then((response) => {
            if (data.status >= 200 && data.status < 300) {
              setEstadoPost(2);
              obtenerCostoBeneficio();
            } else if (data.status >= 500) {
              setEstadoPost(5);
            } else if (data.status >= 400 && data.status < 500) {
              setEstadoPost(4);
            }
          })
        )
        .catch(function (err) { });
    }
  };
useEffect(() => {
  // Solo calcula si hay amenazas seleccionadas y exposición aún no se ha calculado
  if (
    selectedAmenazas &&
    selectedAmenazas.length > 0 &&
    resumenData &&
    riesgosMitiga &&
    riesgosMitiga.length > 0 &&
    (exposicion === "" || exposicion === 0) &&
    valTipoControl &&
    resumenData
  ) {
    handleChangeAmenazas(selectedAmenazas);
  }
}, [selectedAmenazas, resumenData, riesgosMitiga, valTipoControl, amenazaAnalizar, valTipoControl]);

  const formatNumero = (value) => {
    if (!value) return "";
    return new Intl.NumberFormat("es-CO").format(value);
  };

  function llenarTipoComp(data) {
    let tipo = [];
    for (const clave in data) {
      if (
        data[clave]["codigogeneral"] === "COM" &&
        data[clave]["estado"] === true
      ) {
        tipo.push(data[clave]);
      }
    }
    tipo.push({
      idtipo_activo: "",
      codigogeneral: "",
      estado: true,
      codigogeneral: "",
      tipo_activo: "Ninguno(No será considerado en las EROS)",
    });
    return tipo;
  }
  const tipoComp = llenarTipoComp(tipoComp2);
  const enviarImplemenXControl = () => {
    let dato = [];
    implementadorXControl.map((n) => {
      dato.push({
        idimplementadorporcontrol: 0,
        idcontrol: n.idcontrol,
        idimplementador: localStorage.getItem("idimplementador"),
        disp_numerico1: 1,
      });
    });
    fetch(
      process.env.REACT_APP_API_URL +
      "maestro/implementador_por_control/" +
      localStorage.getItem("idimplementador") +
      "/",
      {
        method: "PUT",
        body: JSON.stringify(dato),
        headers: {
          "Content-type": "application/json; charset=UTF-8",
          Authorization: "Bearer " + token,
        },
      }
    )
      .then((data) =>
        data.json().then((response) => {
          if (data.status >= 200 && data.status < 300) {
            setEstadoPost(2);
            const controlesAsociados = async () => {
              const result = await fetch(
                process.env.REACT_APP_API_URL +
                "maestro/implementador_por_control/" +
                localStorage.getItem("idimplementador") +
                "/",
                {
                  method: "GET",
                  headers: {
                    Accept: "application/json",
                    Authorization: "Bearer " + token,
                  },
                }
              );
              let dataImplementadorControl = await result.json();
              setImplementadorXControl(dataImplementadorControl);
              const newSelecteds = dataImplementadorControl.map(
                (n) => n.idcontrol
              );
              setControlSelected(newSelecteds);
            };
            controlesAsociados();
          } else if (data.status >= 500) {
            setEstadoPost(5);
          } else if (data.status >= 400 && data.status < 500) {
            setEstadoPost(4);
          }
        })
      )
      .catch(function (err) { });
  };
  const maptipodespliegue = DataDespliegue.map((option) => ({
    value: option.idparametrosgenerales,
    label: option.vlrmetrica,
  }));
  const mapcompnusada = companiaDatOption.map((option) => ({
    value: option.idcompania,
    label: option.compania,
  }));

  const handleResumenChange = (nuevoResumen) => {
    console.log("Resumen recibido del hijo:", nuevoResumen);
    setResumenData(nuevoResumen);
  };
  
  const handleResumenReady = () => {
    // ya están los datos del resumen, calcula exposición
    if (selectedAmenazas?.length && riesgosMitiga?.length && valTipoControl) {
      handleChangeAmenazas(selectedAmenazas);
    }
  };


  const handleChange = (e) => {
    setSelectedValueCompania({ value: e.value, label: e.label });
  };

  const handleChangeAmenazas = (selected) => {
    setSelectedAmenazas(selected || []);

    //Si selected es null, asignar exposición 0
    if (!selected || selected.length === 0) {
      setExposicion(0);
      return;
    }

    if (!resumenData || !riesgosMitiga || riesgosMitiga.length === 0) {
      setExposicion(0);
      return;
    }

    let p50_total = 0;
    let p95_total = 0;
    let p99_total = 0;

    riesgosMitiga.forEach((riesgo) => {
      const key = riesgo.value;
      const datos = resumenData[key];
      if (datos) {
        p50_total += Number(datos.aporte_control_p50_introducir || 0);
        p95_total += Number(datos.aporte_control_p95_introducir || 0);
        p99_total += Number(datos.aporte_control_p99_introducir || 0);
      }
    });

    let exposicionBase = 0;
    if (valTipoControl?.label === "Correctivos") {
      exposicionBase = p50_total * 0.5 + (p99_total - p50_total) * 0.01;
    } else {
      exposicionBase = p50_total * 0.5 + (p95_total - p50_total) * 0.05;
    }

    const numAmenazas = amenazaAnalizar?.length || 1;

    const NumAmenazaSelect = selected?.length || 1;

    const exposicionFinal = (exposicionBase * NumAmenazaSelect) / numAmenazas;

    setExposicion(exposicionFinal.toFixed(2));
  };

  const MySelect = (props) => (
    <Select
      {...props}
      className="texto"
      options={props.options}
      placeholder={props.placeholder}
    />
  );
  const handleChangeStateEstado = (event) => {
    setCheckedEstado(event.target.checked);
    if (stateEstado == "Activo") {
      setStateEstado("Inactivo");
    } else {
      setStateEstado("Activo");
    }
  };
  const opcionesAmenazaAnalizar = [
    { value: "todos", label: "Todos" },
    { value: "app1", label: "App1" },
    { value: "app2", label: "App2" },
    { value: "app3", label: "App3" },
    { value: "app4", label: "App4" },
  ];

  const opcionesMoneda = [
    { value: "USD", label: "USD" },
    { value: "COP", label: "COP" },
    { value: "GTQ", label: "GTQ" },
  ];

  const opcionesPeriodicidad = [
    { value: "Anual", label: "Anual" },
    { value: "Semestral", label: "Semestral" },
    { value: "Trimestral", label: "Trimestral" },
    { value: "Mensual", label: "Mensual" },
    { value: "Única vez", label: "Única vez" },
  ];

  const factoresPeriodicidad = {
    Anual: 1,
    Semestral: 2,
    Trimestral: 4,
    Mensual: 12,
    "Única vez": 1,
  };

  const handleChangeStateMapeadoControles = (event) => {
    setCheckedMapeadoControles(event.target.checked);
    if (stateMapeadoControles === "Si") {
      setStateMapeadoControles("No");
    } else {
      setStateMapeadoControles("Si");
    }
    console.log(stateMapeadoControles, "el mapeado en contorles es");
  };
  const onChangeCategoriaControl = (value) => {
    setvalCapaControl([]);
    setvalCategoriaControl(value);
    if (value.label === "Controles generales de ciber seguridad") {
      setCapaControlTemp(
        capaControl.filter((capa) => capa.label === "Monitoreo y Respuesta")
      );
    } else if (
      value.label ===
      "Controles específicos sobres los componentes tecnológicos"
    ) {
      setCapaControlTemp(
        capaControl.filter(
          (capa) =>
            capa.label === "Seguridad perimetral" ||
            capa.label === "Seguridad de la red" ||
            capa.label === "Seguridad de endpoints" ||
            capa.label === "Seguridad de aplicaciones"
        )
      );
    } else if (value.label === "Controles específicos sobre los datos") {
      setCapaControlTemp(
        capaControl.filter((capa) => capa.label === "Seguridad de los datos")
      );
    } else {
      setCapaControlTemp([]);
    }
  };
  const onChangeTipoControl = (value) => {
    setvalTipoControl(value);
  };
  const onChangeCapaControl = (value) => {
    setvalCapaControl(value);
  };
  const onChangeNivelAutomatizacion = (value) => {
    setNivelAutomatizacion(value);
  };
  const onChangeCompania = (value) => {
    setCompaniaSelect(value);
  };
  const handleOnchangecompn = (val) => {
    setvaluecompnusada(val);
  };
  const onChangeAmenaza = (value) => {
    setvalAmenaza(value);
  };
  const changeCompT = (val) => {
    setCodigoActivo(val);
  };
  const changeCanalT = (val) => {
    setCanalT(val);
  };
  const changeDesp = (val) => {
    setvaluedesp(val);
  };
  const handleChangeNombre = (val) => {
    setValueNombre(val.target.value);
  };
  const handleChangeFabricante = (val) => {
    setValueFabricante(val.target.value);
  };
  const handleChangeDescripcion = (val) => {
    setValueDescripcion(val.target.value);
  };
  const handleChangeZero = (val) => {
    setValueZero(val);
  };
  const handleChangeDominio = (val) => {
    setValueDominio(val);
  };
  const handleChangeTipoUsuario = (val) => {
    setValueTipoUsuario(val);
  };
  const handleChangeAreaResponsable = (val) => {
    setValueAreaResponsable(val);
  };
  const handleChangeDocumentacion = (val) => {
    setValueDocumentacion(val.target.value);
  };
  const handleChangeEficacia = (val) => {
    const newValue = val.target.value;
    console.log("New Value", newValue);
    if (parseFloat(newValue) >= 0 && parseFloat(newValue) <= 1) {
      setValueEficacia(newValue);
      setErrorEO(false);
      setValueDisenoControl2(valueDisenoControl * newValue);
    } else if (
      newValue === "" ||
      newValue === null ||
      newValue === undefined ||
      newValue === 0
    ) {
      setValueEficacia(newValue);
      setValueDisenoControl2(valueDisenoControl);
    } else {
      setErrorEO(true);
    }
  };

  const sendData = (event) => {
    console.log("Estoy en el sendData PUT");
    event.preventDefault();

    if (
      valueNombre === "" ||
      valueDescripcion === "" ||
      companiaSelect === null ||
      labelCompUsada === "" ||
      nivelAutomatizacion === "" ||
      valTipoControl === "" ||
      labelTipoDespliegue === ""
    ) {
      setEstadoPost(6);
      return;
    } else {
      var data = JSON.stringify({
        idimplementador: localStorage.getItem("idimplementador"),
        idcompania: parseInt(companiaSelect.idcompania),
        nombre: valueNombre,
        descripcion: valueDescripcion,
        nivel_automatizacion: nivelAutomatizacion.nombre,
        estado: checkedEstado,
        mapeado_en_controles: stateMapeadoControles === "Si" ? 1 : 0,
        categoria_control: valcategoriaControl.label
          ? valcategoriaControl.label
          : null,
        tipo_control: valTipoControl.label ? valTipoControl.label : null,
        capa_control: labelCapaControl ? labelCapaControl : null,
        fabricante: valueFabricante ? valueFabricante : null,
        companias_usan: labelCompUsada ? labelCompUsada : null,
        tipo_despliegue: labelTipoDespliegue ? labelTipoDespliegue : null,
        tipo_canal: canalT.vlrmetrica ? canalT.vlrmetrica : null,
        idtipo_activo: codigoActivo.idtipo_activo
          ? codigoActivo.idtipo_activo
          : null,
        eficaciaoperativa: valueEficacia ? parseFloat(valueEficacia).toFixed(4) : null,
        pruebatecnica: valuePruebaTecnica ? parseFloat(valuePruebaTecnica).toFixed(4) : null,
        efectividad: valueDisenoControl2 ? parseFloat(valueDisenoControl2).toFixed(4) : null,
        idactivo: componentesSelected ? componentesSelected[0] : null,
        zero_trust: valueZero.label ? valueZero.label : null,
        dominio: valueDominio.label ? valueDominio.label : null,
        tipo_de_usuario: valueTipoUsuario.label ? valueTipoUsuario.label : null,
        area_responsable: valueAreaResponsable.label
          ? valueAreaResponsable.label
          : null,
        documentacion: valueDocumentacion ? valueDocumentacion : null,
        niveles: selectedIdsString ? selectedIdsString.toString() : null,
        amenazas: labelAmenaza ? labelAmenaza : null,
      });
      fetch(
        process.env.REACT_APP_API_URL +
        "maestro/implementadores/" +
        localStorage.getItem("idimplementador") +
        "/" +
        localStorage.getItem("idcompania") +
        "/",
        {
          method: "PUT",
          body: data,
          headers: {
            "Content-type": "application/json; charset=UTF-8",
            Authorization: "Bearer " + token,
          },
        }
      )
        .then((data) =>
          data.json().then((response) => {
            if (data.status >= 200 && data.status < 300) {
              setEstadoPost(2);
              enviarImplemenXControl();
            } else if (data.status >= 500) {
              setEstadoPost(5);
            } else if (data.status >= 400 && data.status < 500) {
              setEstadoPost(4);
            }
          })
        )
        .catch(function (err) { });

      setValidated(true);
    }
  };
  function ComponentInfraModal(props) {
    const [queryText, setqueryText] = React.useState("");
    const [contTecno, setContTecno] = React.useState(props.componentes);
    const [dense, setDense] = React.useState(false);
    const [order, setOrder] = React.useState("asc");
    const [orderBy, setOrderBy] = React.useState("name");
    const [page, setPage] = React.useState(0);
    const [rowsPerPage, setRowsPerPage] = React.useState(10);
    const classes = useStylesModal();

    const handleRequestSort = (event, property) => {
      const isAsc = orderBy === property && order === "asc";
      setOrder(isAsc ? "desc" : "asc");
      setOrderBy(property);
    };
    const handleSelectAllClick = (event) => {
      if (event.target.checked) {
        const newSelecteds = controles.map((n) => n.idcontrol);
        setContTecno(newSelecteds);
        return;
      }
      setContTecno([]);
    };
    const handleClick = (event, id, idtipo_activo, obj) => {
      console.log("Estoy en handleClick");
      const selectedIndex = contTecno.indexOf(id);
      let newSelected = [];

      if (selectedIndex === -1) {
        newSelected.push(id);
      } else {
        newSelected = contTecno.filter((item) => item !== id);
      }
      setContTecno(newSelected);
    };
    const handleChangePage = (event, newPage) => {
      setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
      setRowsPerPage(parseInt(event.target.value, 10));
      setPage(0);
    };

    const isSelected = (idcontrol) => contTecno.indexOf(idcontrol) !== -1;
    const comData = stableSort(modalCompo, getComparator(order, orderBy))
      .filter((row) =>
        row.idactivo.toString().includes(queryText.toLowerCase())
      )
      .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage);
    const final_data_ifrastructure = comData;
    const handleChangeDense = (event) => {
      setDense(event.target.checked);
    };
    return (
      <>
        <Modal
          {...props}
          size="xl"
          aria-labelledby="contained-modal-title-vcenter"
          centered
        >
          <Modal.Header closeButton>
            <Modal.Title id="contained-modal-title-vcenter">
              Añadir componente principal
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className={classes.root}>
              <Paper className={classes.paper}>
                <Row>
                  <Col sm={4} xs={2}>
                    <Form className="buscar">
                      <Form.Control
                        type="text"
                        placeholder="Buscar"
                        onChange={(e) => setqueryText(e.target.value)}
                        style={{ align: "center" }}
                      />
                    </Form>
                  </Col>
                  <Col sm={4} xs={6}>
                    <Button
                      className="botonPositivo"
                      style={{ marginTop: "1%", width: "100%" }}
                      onClick={() => completarTabla(contTecno, "detalles")}
                    >
                      {" "}
                      Guardar{" "}
                    </Button>
                  </Col>
                </Row>
                <TableContainer className={classes.container}>
                  <Table
                    stickyHeader
                    className={classes.table}
                    aria-labelledby="tableTitle"
                    size={dense ? "small" : "medium"}
                    aria-label="enhanced table"
                  >
                    <EnhancedTableHeadCompP
                      classes={classes}
                      numSelected={contTecno.length}
                      order={order}
                      orderBy={orderBy}
                      onRequestSort={handleRequestSort}
                      rowCount={modalCompo.length}
                    />
                    <TableBody>
                      {final_data_ifrastructure?.map((row, index) => {
                        const isItemSelected = isSelected(row.idactivo);
                        const labelId = `enhanced-table-checkbox-${index}`;
                        return (
                          <TableRow
                            onClick={(event) =>
                              handleClick(
                                event,
                                row.idactivo,
                                row.idtipo_activo,
                                row
                              )
                            }
                            role="checkbox"
                            aria-checked={isItemSelected}
                            tabIndex={-1}
                            key={row.idactivo}
                            selected={isItemSelected}
                          >
                            <TableCell padding="checkbox">
                              <Checkbox
                                checked={isItemSelected}
                                inputProps={{ "aria-labelledby": labelId }}
                              />
                            </TableCell>
                            <TableCell
                              component="th"
                              id={labelId}
                              scope="row"
                              padding="none"
                            >
                              {row.idactivo}
                            </TableCell>
                            <TableCell align="left">{row.nombre}</TableCell>
                            <TableCell align="left">
                              {row.descripcion}
                            </TableCell>
                            <TableCell align="left">
                              {row.UsuarioResponsableTI}
                            </TableCell>
                            <TableCell align="left">
                              {row.UsuarioResponsableNegocio}
                            </TableCell>
                          </TableRow>
                        );
                      })}
                    </TableBody>
                  </Table>
                </TableContainer>
                <div>
                  <TablePagination
                    rowsPerPageOptions={[10, 20, 30]}
                    component="div"
                    count={modalCompo.length}
                    rowsPerPage={rowsPerPage}
                    page={page}
                    onPageChange={handleChangePage}
                    onRowsPerPageChange={handleChangeRowsPerPage}
                  />
                </div>
              </Paper>
              <FormControlLabel
                control={
                  <Switch checked={dense} onChange={handleChangeDense} />
                }
                label="Vista compacta"
              />
            </div>
          </Modal.Body>
        </Modal>
      </>
    );
  }

  function MyVerticallyCenteredModal(props) {
    const [queryText, setqueryText] = React.useState("");
    const [contTecno, setContTecno] = React.useState(props.componentes);
    const [dense, setDense] = React.useState(false);
    const [order, setOrder] = React.useState("asc");
    const [orderBy, setOrderBy] = React.useState("name");
    const [page, setPage] = React.useState(0);
    const [rowsPerPage, setRowsPerPage] = React.useState(10);
    const classes = useStylesModal();
    const handleRequestSort = (event, property) => {
      const isAsc = orderBy === property && order === "asc";
      setOrder(isAsc ? "desc" : "asc");
      setOrderBy(property);
    };
    const handleSelectAllClick = (event) => {
      if (event.target.checked) {
        const newSelecteds = controles.map((n) => n.idcontrol);
        setContTecno(newSelecteds);
        return;
      }
      setContTecno([]);
    };
    const handleClick = (event, id, idtipo_activo, obj) => {
      const selectedIndex = contTecno.indexOf(id);
      let newSelected = [];
      if (selectedIndex === -1) {
        newSelected = newSelected.concat(contTecno, id);
      } else if (selectedIndex === 0) {
        newSelected = newSelected.concat(contTecno.slice(1));
      } else if (selectedIndex === contTecno.length - 1) {
        newSelected = newSelected.concat(contTecno.slice(0, -1));
      } else if (selectedIndex > 0) {
        newSelected = newSelected.concat(
          contTecno.slice(0, selectedIndex),
          contTecno.slice(selectedIndex + 1)
        );
      }
      setContTecno(newSelected);
    };
    const handleChangePage = (event, newPage) => {
      setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
      setRowsPerPage(parseInt(event.target.value, 10));
      setPage(0);
    };
    const isSelected = (idcontrol) => contTecno.indexOf(idcontrol) !== -1;

    return (
      <Modal
        {...props}
        size="xl"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        backdrop="static"
      >
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter">
            Añadir Estandar Nist
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className={classes.root}>
            <Row>
              <Col sm={4} xs={2}>
                <Form className="buscar">
                  <Form.Control
                    type="text"
                    placeholder="Buscar"
                    onChange={(e) => setqueryText(e.target.value)}
                    style={{ align: "center" }}
                  />
                </Form>
              </Col>
              <Col sm={4} xs={6}></Col>
              <Col sm={4} xs={6}>
                <Button
                  className="botonPositivo"
                  style={{ marginTop: "1%", width: "100%" }}
                  onClick={() => completarTabla(contTecno)}
                >
                  {" "}
                  Guardar{" "}
                </Button>
              </Col>
            </Row>
            <Paper className={classes.paper}>
              <TableContainer className={classes.container}>
                <Table
                  stickyHeader
                  className={classes.table}
                  aria-labelledby="tableTitle"
                  size={dense ? "small" : "medium"}
                  aria-label="enhanced table"
                >
                  <EnhancedTableHead
                    classes={classes}
                    numSelected={contTecno.length}
                    order={order}
                    orderBy={orderBy}
                    onSelectAllClick={handleSelectAllClick}
                    onRequestSort={handleRequestSort}
                    rowCount={controles.length}
                  />
                  <TableBody>
                    {stableSort(controles, getComparator(order, orderBy))
                      .filter((row) =>
                        row.idcontrol
                          .toString()
                          .includes(queryText.toLowerCase())
                      )
                      .slice(
                        page * rowsPerPage,
                        page * rowsPerPage + rowsPerPage
                      )
                      .map((row, index) => {
                        const isItemSelected = isSelected(row.idcontrol);
                        const labelId = `enhanced-table-checkbox-${index}`;
                        return (
                          <TableRow
                            onClick={(event) =>
                              handleClick(event, row.idcontrol, row)
                            }
                            role="checkbox"
                            aria-checked={isItemSelected}
                            tabIndex={-1}
                            key={row.idcontrol}
                            selected={isItemSelected}
                          >
                            <TableCell padding="checkbox">
                              <Checkbox
                                checked={isItemSelected}
                                inputProps={{ "aria-labelledby": labelId }}
                              />
                            </TableCell>
                            <TableCell>{row.idcontrol}</TableCell>
                            <TableCell>{row.idcontrol_nist}</TableCell>
                            <TableCell>{row.nombre_control}</TableCell>
                          </TableRow>
                        );
                      })}
                  </TableBody>
                </Table>
              </TableContainer>
              <TablePagination
                rowsPerPageOptions={[10, 20, 30]}
                component="div"
                count={controles.length}
                rowsPerPage={rowsPerPage}
                page={page}
                onPageChange={handleChangePage}
                onRowsPerPageChange={handleChangeRowsPerPage}
                labelRowsPerPage={"Filas por página"}
              />
            </Paper>
          </div>
        </Modal.Body>
        setImplementador
        <Modal.Footer></Modal.Footer>
      </Modal>
    );
  }

  const completarTabla = (obj, id) => {
    console.log("Estoy en completarTabla");
    let temp = [];
    setControlSelected(obj);
    //for (let i = 0; i < obj.length; i++) {
    //    temp.push(
    //        controles.filter((dato) => dato.idcontrol === obj[i])[0]
    //    );
    //}
    console.log("temp", temp);
    setImplementadorXControl(temp);
    setModalShow(false);
    switch (id) {
      case "detalles":
        setComponentesSelected(obj);
        for (let i = 0; i < obj.length; i++) {
          temp.push(modalCompo.filter((dato) => dato.idactivo === obj[i])[0]);
        }
        setRowsC(temp);
        setModalShowCompP(false);
        break;

      default:
        break;
    }
  };
  const handleChangeTab = (event, newValue) => {
    setActiveTab(newValue);
  };
  const [selectedInfra, setSelectedInfra] = useState([]);
  const isSelectedInfra = (name) => selectedInfra.indexOf(name) !== -1;
  const handleClickInfra = (event, name) => {
    console.log("Estoy en handleClickInfra");
    const selectedIndex = selectedInfra.indexOf(name);

    let newSelected = [];

    if (selectedIndex === -1) {
      newSelected = newSelected.concat([], name);
      //SetButtonEdit(true);
    } else {
      //SetButtonEdit(false);
    }

    setSelectedInfra(newSelected);
  };

  const mapearNiveles = (data) => {
    const nivelesPrincipales = data.filter(
      (item) => parseInt(item.disp_numerico1) === 0
    );
    const seccionesMapeadas = nivelesPrincipales.map((nivel) => {
      const hijos = data.filter(
        (item) =>
          parseInt(item.disp_numerico1) ===
          parseInt(nivel.idparametrosgenerales)
      );
      return {
        id: nivel.idparametrosgenerales,
        titulo: nivel.vlrmetrica,
        hijos: hijos.map((hijo) => ({
          id: hijo.idparametrosgenerales,
          nombre: hijo.vlrmetrica,
          checked: false,
        })),
      };
    });
    return seccionesMapeadas;
  };

  const toggleSection = (index) => {
    setActiveSection(activeSection === index ? null : index);
  };

  const handleCheckboxChange = (id) => {
    setSelectedCheckboxes((prevSelected) => {
      if (prevSelected.includes(id)) {
        return prevSelected.filter((checkboxId) => checkboxId !== id);
      } else {
        return [...prevSelected, id];
      }
    });
  };

  const selectedIdsString = selectedCheckboxes.join(",");

  const renderTooltip = (value) => (
    <Tooltip
      title={
        <React.Fragment>
          <List>
            <ListItem>
              <ListItemText primary={value} />
            </ListItem>
          </List>
        </React.Fragment>
      }
    >
      <HelpOutline />
    </Tooltip>
  );

  const classes = useStylesModal();
  return (
    <>
      <AlertDismissibleExample alerta={estadoPOST} />
      <AppBar
        position="static"
        style={{ backgroundColor: "#2c2a29", color: "#ffffff" }}
      >
        <Tabs
          value={activeTab}
          onChange={handleChangeTab}
          aria-label="simple tabs example"
        >
          <Tab
            label="General"
            style={{ color: "#ffffff", padding: "3px 7px 3px" }}
          />
          <Tab
            label="Arquitectura"
            style={{ color: "#ffffff", padding: "3px 7px 3px" }}
          />
          <Tab
            label="Detalle Riesgo"
            style={{ color: "#ffffff", padding: "3px 7px 3px" }}
          />
            <Tab
              label="Costo-Beneficio"
              style={{ color: "#ffffff", padding: "3px 7px 3px" }}
            />
        </Tabs>
      </AppBar>

      {activeTab === 0 && (
        <>
          <Row>
            <Col>
              {" "}
              <h2 className="titulo" style={{ marginTop: "20px" }}>
                Editar Control
              </h2>
            </Col>
          </Row>
          <hr />
          <Form
            id="formData"
            onSubmit={(e) => sendData(e)}
            noValidate
            validated={validated}
          >
            <Row className="mb-3">
              <Col sm={2} xs={12}>
                <label className="label forn-label">Id Control</label>
              </Col>
              <Col sm={2} xs={12}>
                <input
                  type="text"
                  disabled
                  className="form-control text-center"
                  placeholder="ID Automático"
                  id="IDImplementador"
                  value={localStorage.getItem("idimplementador")}
                ></input>
              </Col>
              <Col sm={2} xs={12}>
                <label className="label form-label">Nombre Control*</label>
              </Col>
              <Col sm={4} xs={12}>
                <input
                  type="text"
                  disabled
                  className="form-control text-center"
                  placeholder="Nombre del Control"
                  required
                  id="NombreImplementador"
                  onChange={handleChangeNombre}
                  value={valueNombre}
                ></input>
                <Form.Control.Feedback type="invalid">
                  Por favor introduzca un nombre.
                </Form.Control.Feedback>
              </Col>
              <Col sm={1} xs={12}>
                <label className="label forn-label">Estado*</label>
              </Col>
              <Col sm={1} xs={12}>
                <FormControlLabel
                  disabled
                  control={<Switch checked={checkedEstado} />}
                  label={stateEstado}
                  onChange={handleChangeStateEstado}
                />
              </Col>
            </Row>
            <Row className="mb-3">
              <Col sm={2} xs={12}>
                <label className="label forn-label">Compañía*</label>
              </Col>
              <Col sm={4} xs={10}>
                <Select
                  isDisabled
                  placeholder={"Seleccione la compañía..."}
                  getOptionLabel={(option) => option.compania}
                  getOptionValue={(option) => option.idcompania}
                  options={companiaDatOption}
                  onChange={onChangeCompania}
                  styles={stylesSelect}
                  value={companiaSelect}
                />
                <Form.Control.Feedback type="invalid">
                  Por favor seleccione una compañía.
                </Form.Control.Feedback>
              </Col>
              <Col sm={2} xs={12}>
                <label className="label forn-label">
                  Compañías que la usan*
                </label>
              </Col>
              <Col sm={4} xs={10}>
                <Select
                  isMulti
                  styles={stylesSelect}
                  style={{ width: "100%" }}
                  placeholder="Seleccione compañías que la usan..."
                  onChange={handleOnchangecompn}
                  options={mapcompnusada}
                  id="companiausada"
                  value={valuecompnusada}
                />
                <Form.Control.Feedback type="invalid">
                  Por favor seleccione una compañía.
                </Form.Control.Feedback>
              </Col>
            </Row>
            <Row className="mb-3">
              <Col sm={2} xs={12}>
                <label className="label form-label">Fabricante</label>{" "}
                {/*TODO: guaradar en estado*/}
              </Col>
              <Col sm={4} xs={12}>
                <input
                  type="text"
                  className="form-control text-center"
                  placeholder="Nombre del Fabricante"
                  id="fabricante"
                  onChange={handleChangeFabricante}
                  value={valueFabricante}
                ></input>
              </Col>
              <Col sm={2} xs={12}>
                <label className="label forn-label">
                  Nivel de Automatización*
                </label>
              </Col>
              <Col sm={4} xs={12}>
                <Select
                  isDisabled
                  placeholder={"Seleccione nivel de automatización"}
                  getOptionLabel={(opcion_nivel_automatizacion) =>
                    opcion_nivel_automatizacion.nombre
                  }
                  getOptionValue={(opcion_nivel_automatizacion) =>
                    opcion_nivel_automatizacion.nombre
                  }
                  options={opcion_nivel_automatizacion}
                  onChange={onChangeNivelAutomatizacion}
                  styles={stylesSelect}
                  value={nivelAutomatizacion}
                />
                <Form.Control.Feedback type="invalid">
                  Por favor seleccione el nivel de Automatización.
                </Form.Control.Feedback>
              </Col>
            </Row>
            <Row className="mb-3">
              <Col sm={2} xs={12}>
                <label className="label form-label">Descripción*</label>{" "}
                {/*TODO: guaradar en estado*/}
              </Col>
              <Col sm={10} xs={10}>
                <textarea
                  className="form-control text-center"
                  placeholder="Descripción del Control"
                  rows="3"
                  required
                  id="Descripcion"
                  onChange={handleChangeDescripcion}
                  value={valueDescripcion}
                ></textarea>
                <Form.Control.Feedback type="invalid">
                  Por favor introduzca una descripción.
                </Form.Control.Feedback>
              </Col>
            </Row>

            <Row className="mb-3">
              <Col sm={2} xs={12}>
                <label className="label forn-label">Tipo de Control*</label>
              </Col>
              <Col sm={4} xs={12}>
                <Select
                  isDisabled
                  placeholder={"Seleccione el tipo de Control"}
                  options={tipoControl}
                  onChange={onChangeTipoControl}
                  styles={stylesSelect}
                  value={valTipoControl}
                />
                <Form.Control.Feedback type="invalid">
                  Por favor seleccione el tipo de control.
                </Form.Control.Feedback>
              </Col>
              <Col sm={2} xs={12}>
                <label className="label forn-label">Tipo Despliegue*</label>
              </Col>
              <Col sm={4} xs={12}>
                <Select
                  isDisabled
                  isMulti
                  style={{ width: "100%" }}
                  styles={stylesSelect}
                  placeholder="Seleccione el tipo de despliegue"
                  onChange={changeDesp}
                  options={maptipodespliegue}
                  id="despliegueT"
                  value={despliegue}
                />
                <Form.Control.Feedback type="invalid">
                  Por favor seleccione un tipo de despliegue.
                </Form.Control.Feedback>
              </Col>
            </Row>
            <hr />
              <div>
                <ControlesProtegidos onResumenChange={handleResumenChange} 
                 onResumenReady={handleResumenReady}/>
              </div>
          </Form>
        </>
      )}
      {activeTab === 1 && (
        <>
          <Form
            id="formData"
            onSubmit={(e) => sendData(e)}
            noValidate
            validated={validated}
          >
            <Row>
              <Col>
                <h2
                  className="titulo"
                  style={{ marginBottom: "20px", marginTop: "20px" }}
                >
                  Arquitectura
                </h2>
                <hr
                  style={{
                    border: "0",
                    borderTop: "1px solid #ccc",
                    margin: "20px 0",
                  }}
                />{" "}
              </Col>
            </Row>
            <Row className="mb-3">
              <Col sm={2} xs={12}>
                <label className="label forn-label">Código</label>
              </Col>
              <Col sm={2} xs={12}>
                <input
                  type="number"
                  className="form-control"
                  placeholder="Código"
                  id="codigo"
                  disabled
                  value={valueCodigo}
                />
              </Col>
              <Col sm={2} xs={12}>
                <label className="label forn-label">Zero Trust</label>
              </Col>
              <Col sm={2} xs={12}>
                {
                  <Select
                    placeholder={"Seleccione un trust"}
                    required
                    isDisabled
                    id="ZeroT"
                    isMulti={false}
                    options={dataZeroTrust}
                    onChange={handleChangeZero}
                    value={valueZero}
                  />
                }
                <Form.Control.Feedback type="invalid">
                  Por favor seleccione un Trust
                </Form.Control.Feedback>
              </Col>

              <Col sm={2} xs={12}>
                <label className="label forn-label">Dominio</label>
              </Col>
              <Col sm={2} xs={12}>
                {
                  <Select
                    placeholder={"Seleccione un dominio"}
                    required
                    isDisabled
                    id="Ddominio"
                    isMulti={false}
                    options={dataDominio}
                    onChange={handleChangeDominio}
                    value={valueDominio}
                  />
                }
                <Form.Control.Feedback type="invalid">
                  Por favor seleccione un Dominio
                </Form.Control.Feedback>
              </Col>
            </Row>

            <Row className="mb-3">
              <Col sm={2} xs={12}>
                <label className="label forn-label">Tipo de usuario</label>
              </Col>
              <Col sm={4} xs={12}>
                {
                  <Select
                    placeholder={"Seleccione un usuario"}
                    required
                    isDisabled
                    id="tusuario"
                    isMulti={false}
                    options={dataTipoUsuario}
                    onChange={handleChangeTipoUsuario}
                    value={valueTipoUsuario}
                  />
                }
                <Form.Control.Feedback type="invalid">
                  Por favor seleccione un Tipo de usuario
                </Form.Control.Feedback>
              </Col>

              <Col sm={2} xs={12}>
                <label className="label forn-label">Area Responsable</label>
              </Col>
              <Col sm={4} xs={12}>
                {
                  <Select
                    placeholder={"Seleccione area de responsable"}
                    required
                    isDisabled
                    id="idRespo"
                    isMulti={false}
                    options={datAreaResponsable}
                    onChange={handleChangeAreaResponsable}
                    value={valueAreaResponsable}
                  />
                }
                <Form.Control.Feedback type="invalid">
                  Por favor seleccione un Responsable
                </Form.Control.Feedback>
              </Col>
            </Row>

            <Row className="mb-3">
              <Col sm={2} xs={12}>
                <label className="label forn-label">Servicio</label>
              </Col>
              <Col sm={4} xs={12}>
                {
                  <Select
                    placeholder={"Seleccione un usuario"}
                    required
                    isDisabled
                    id="tusuario"
                    isMulti={false}
                    // options={dataTipoUsuario}
                    onChange={handleChangeTipoUsuario}
                    value={valueServicio}
                  />
                }
                <Form.Control.Feedback type="invalid">
                  Por favor seleccione un servicio
                </Form.Control.Feedback>
              </Col>

              <Col sm={2} xs={12}>
                <label className="label forn-label">Capacidad</label>
              </Col>
              <Col sm={4} xs={12}>
                {
                  <Select
                    placeholder={"Seleccione area de responsable"}
                    required
                    isDisabled
                    id="idRespo"
                    isMulti={false}
                    //options={datAreaResponsable}
                    onChange={handleChangeAreaResponsable}
                    value={valueCapacidad}
                  />
                }
                <Form.Control.Feedback type="invalid">
                  Por favor seleccione una Capacidad
                </Form.Control.Feedback>
              </Col>
            </Row>

            <Row className="mb-3">
              <Col sm={2} xs={12}>
                <label className="label form-label">Documentacion</label>
              </Col>
              <Col sm={8} xs={10}>
                <textarea
                  className="form-control text-center"
                  placeholder="Documentación"
                  disabled
                  rows="3"
                  id="documentacion"
                  onChange={handleChangeDocumentacion}
                  value={valueDocumentacion}
                ></textarea>
                <Form.Control.Feedback type="invalid">
                  Por favor introduzca una Descripción.
                </Form.Control.Feedback>
              </Col>
            </Row>
            <hr
              style={{
                border: "0",
                borderTop: "1px solid #ccc",
                margin: "20px 0",
              }}
            />
            <Row className="mb-3">
              <Col sm={12} xs={12}>
                <label className="label form-label">
                  Capacidades de la arquitectura
                </label>
              </Col>
            </Row>
            <div className="accordion">
              {sections.map((section, index) => (
                <div key={section.id} className="accordion-item">
                  <div
                    className="accordion-title"
                    onClick={() => toggleSection(index)}
                  >
                    <span>
                      {activeSection === index ? (
                        <KeyboardArrowDownIcon className="accordion-icon" />
                      ) : (
                        <KeyboardArrowRightIcon className="accordion-icon" />
                      )}
                      {section.titulo}
                    </span>
                  </div>
                  <div
                    className={`accordion-content ${activeSection === index ? "open" : ""
                      }`}
                  >
                    {section.hijos.map((hijo) => (
                      <div key={hijo.id} className="checkbox-item">
                        <label htmlFor={`checkbox-${hijo.id}`}>
                          <input
                            type="checkbox"
                            id={`checkbox-${hijo.id}`}
                            checked={selectedCheckboxes.includes(hijo.id)}
                            onChange={() => handleCheckboxChange(hijo.id)}
                          />
                          {hijo.nombre}
                        </label>
                      </div>
                    ))}
                  </div>
                </div>
              ))}
            </div>
            <hr />
            <Row className="mb-3" style={{ padding: "25px 0px" }}>
              <Col sm={4} xs={1}></Col>
              <Col sm={3} xs={3}>
                {" "}
                <Button
                  type="submit"
                  className="botonPositivo"
                  id="send"
                  disabled={idrolUser != 1 && idrolUser != 7}
                >
                  Guardar
                </Button>
              </Col>
              <Col sm={3} xs={3}>
                {" "}
                <Link to="maestro-implementador">
                  <Button
                    className="botonNegativo"
                    disabled={idrolUser != 1 && idrolUser != 7}
                  >
                    Descartar
                  </Button>
                </Link>
              </Col>
            </Row>
          </Form>
        </>
      )}
      {activeTab === 2 && (
        <>
          <MyVerticallyCenteredModal
            componentes={controlSelected}
            show={modalShow}
            onHide={() => {
              setDireccion(false);
              setModalShow(false);
            }}
          />
          <ComponentInfraModal
            componentes={componentesSelected}
            show={modalShowCompP}
            onHide={() => {
              setModalShowCompP(false);
            }}
          />

          <Row>
            <Col>
              <h2 className="titulo" style={{ marginTop: "20px" }}>
                Detalle Riesgo
              </h2>
            </Col>
          </Row>
          <hr />
          <Form
            id="formData"
            onSubmit={(e) => sendData(e)}
            noValidate
            validated={validated}
          >
            <Row className="mb-3">
              <Col sm={2} xs={12}>
                <label className="label forn-label">
                  Categoria del Control
                </label>
              </Col>
              <Col sm={4} xs={12}>
                <Select
                  isDisabled
                  placeholder={"Seleccione la Categoria del Control"}
                  //isDisabled={idrolUser == 7}
                  options={categoriaControl}
                  onChange={onChangeCategoriaControl}
                  styles={stylesSelect}
                  value={valcategoriaControl}
                />
                <Form.Control.Feedback type="invalid">
                  Por favor seleccione la categoria del control.
                </Form.Control.Feedback>
              </Col>
              <Col sm={2} xs={12}>
                <label className="label forn-label">Capa de Control</label>
              </Col>
              <Col sm={4} xs={12}>
                <Select
                  isDisabled
                  isMulti
                  placeholder={"Seleccione la Capa de Control"}
                  //isDisabled={idrolUser == 7}
                  options={capaControlTemp}
                  onChange={onChangeCapaControl}
                  styles={stylesSelect}
                  value={valcapaControl}
                />
                <Form.Control.Feedback type="invalid">
                  Por favor seleccione la Capa de control.
                </Form.Control.Feedback>
              </Col>
            </Row>
            <Row className="mb-3">
              <Col sm={2} xs={12}>
                <label className="label forn-label">
                  Amenazas que mitiga el Control
                </label>
              </Col>
              <Col sm={4} xs={12}>
                <Select
                  isDisabled
                  isMulti
                  placeholder={"Seleccione las amenazas"}
                  options={listaAmenaza}
                  onChange={onChangeAmenaza}
                  styles={stylesSelect}
                  value={valAmenaza}
                />
                <Form.Control.Feedback type="invalid">
                  Por favor seleccione la Capa de control.
                </Form.Control.Feedback>
              </Col>
              <Col sm={2} xs={12}>
                <label className="label forn-label">Tipo Componente</label>
              </Col>
              <Col sm={4} xs={12}>
                {
                  <Select
                    isDisabled
                    placeholder={"Seleccione tipo de componente"}
                    //isDisabled={idrolUser == 7}
                    onChange={changeCompT}
                    required
                    id="componenteT"
                    getOptionLabel={(option) => option.tipo_activo}
                    getOptionValue={(option) => option.idtipo_activo}
                    options={tipoComp}
                    value={codigoActivo}
                  />
                }
                <Form.Control.Feedback type="invalid">
                  Por favor seleccione un tipo de componente.
                </Form.Control.Feedback>
              </Col>
            </Row>
            <Row className="mb-3">
              <Col sm={2} xs={12}>
                <label className="label forn-label">
                  Mapeado en Estandar Nist
                </label>
              </Col>
              <Col sm={4} xs={12}>
                <FormControlLabel
                  control={
                    <Switch
                      disabled
                      checked={checkedMapeadoControles}
                    //disabled={idrolUser == 7}
                    />
                  }
                  label={stateMapeadoControles}
                  onChange={handleChangeStateMapeadoControles}
                  value={stateMapeadoControles}
                />
              </Col>
              <Col sm={2} xs={12}>
                <label className="label forn-label">Tipo Canal</label>
              </Col>
              <Col sm={4} xs={12}>
                <Select
                  isDisabled
                  placeholder={"Seleccione tipo de canal"}
                  //isDisabled={idrolUser == 7}
                  required
                  onChange={changeCanalT}
                  id="canalT"
                  getOptionLabel={(option) => option.vlrmetrica}
                  getOptionValue={(option) => option.idparametrosgenerales}
                  options={DataCanal}
                  value={canalT}
                />
                <Form.Control.Feedback type="invalid">
                  Por favor seleccione un tipo de canal.
                </Form.Control.Feedback>
              </Col>
            </Row>
            <Row className="mb-3">
              <Col sm={2} xs={12}>
                <label className="label forn-label">
                  Performance del control{" "}
                  {renderTooltip(
                    "Solo diligenciar en caso de tener un indicador que mida el desempeño del control, debe de ser ingresado como la media de las observaciones del último año. El valor debe oscilar entre 0 y 1, siendo 1 el mejor performance"
                  )}
                </label>
              </Col>
              <Col sm={2} xs={12}>
                <TextField
                  type="number"
                  id="porcentajeEficacia"
                  name="porcentajeEficacia"
                  label="Ingrese valor"
                  variant="outlined"
                  error={errorEO}
                  disabled={idrolUser == 7}
                  helperText={errorEO ? "El valor debe estar entre 0 y 1." : ""}
                  onChange={handleChangeEficacia}
                  value={valueEficacia}
                  InputProps={{
                    inputProps: {
                      min: 0,
                      max: 1,
                      step: 0.01,
                      type: "number",
                    },
                  }}
                  sx={{
                    width: "100%",
                    zIndex: 0,
                    // Color del número (dinámico)
                    "& .MuiOutlinedInput-input": {
                      color: colorEficacia,
                      fontWeight: 700,
                      transition: "color 120ms linear",
                    },
                    // Borde según color
                    "& .MuiOutlinedInput-notchedOutline": {
                      borderColor: colorEficacia,
                      transition: "border-color 120ms linear",
                    },
                    "&:hover .MuiOutlinedInput-notchedOutline": {
                      borderColor: colorEficacia,
                    },
                    "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                      borderColor: colorEficacia,
                      boxShadow: `0 0 0 2px color-mix(in oklab, ${colorEficacia} 25%, transparent)`,
                    },
                    "& .MuiInputLabel-root.Mui-focused": {
                      color: colorEficacia,
                    },
                  }}
                />
              </Col>
              <Col sm={2} xs={12}>
                <label className="label forn-label">
                  Vulnerabilidad del control{" "}
                  {renderTooltip(
                    "Se calculará una vez se guarde el control si este está asociado a un componente principal. El valor corresponde al peso de las vulnerabilidades en la mitigación del control, mientras más cercano a 0, mejor"
                  )}
                </label>
              </Col>
              <Col sm={2} xs={12}>
                <TextField
                  id="porcentajePruebaTecnica"
                  name="porcentajePruebaTecnica"
                  variant="outlined"
                  disabled
                  value={
                    valuePruebaTecnica
                      ? parseFloat(valuePruebaTecnica).toFixed(4)
                      : "No Aplica"
                  }
                  sx={{
                      width: "100%",
                      zIndex: 0,
                      "& .MuiOutlinedInput-input": {
                        fontWeight: 800,
                        background: "linear-gradient(90deg, #9E9E9E , #d32f2f 0%, #f57c00 35%, #fbc02d 65%, #388e3c 100%)",
                        WebkitBackgroundClip: "text",
                        WebkitTextFillColor: "transparent",
                        backgroundClip: "text",
                        color: "transparent",
                      },
                      "& .MuiOutlinedInput-notchedOutline": {
                        borderColor: "#9e9e9e",
                      },
                    }}
                />
              </Col>
              <Col sm={2} xs={12}>
                <label className="label forn-label">
                  Diseño Control{" "}
                  {renderTooltip(
                    "Se calcula por medio de la Naturaleza, Automatización, Performance y Vulnerabilidad. El valor maximo es 1"
                  )}
                </label>
              </Col>
              <Col sm={2} xs={12}>
                <TextField
                  id="porcentajeEficacia"
                  name="porcentajeEficacia"
                  variant="outlined"
                  disabled
                  value={
                    valueDisenoControl2
                      ? parseFloat(valueDisenoControl2).toFixed(4)
                      : parseFloat(valueDisenoControl).toFixed(4)
                  }
                  sx={{
                      width: "100%",
                      zIndex: 0,
                      "& .MuiOutlinedInput-input": {
                        fontWeight: 800,
                        background: "linear-gradient(90deg, #d32f2f 0%, #f57c00 35%, #fbc02d 65%, #388e3c 100%)",
                        WebkitBackgroundClip: "text",
                        WebkitTextFillColor: "transparent",
                        backgroundClip: "text",
                        color: "transparent",
                      },
                      "& .MuiOutlinedInput-notchedOutline": {
                        borderColor: "#9e9e9e",
                      },
                    }}
                />
              </Col>
            </Row>
            <hr />
            <Row className="mb-3">
              <Col md={10}>
                {" "}
                <h2 className="subtitulo">Añadir Estandar Nist</h2>
              </Col>
              <Col md={2}>
                <Button
                  className="botonIngreso"
                  disabled={idrolUser == 7}
                  onClick={() => {
                    setModalShow(true);
                    setDireccion(true);
                  }}
                >
                  Añadir
                </Button>{" "}
              </Col>
            </Row>
            <Row className="mb-3">
              <TableContainer
                component={Paper}
                className="table table-bordered"
              >
                <Table aria-label="customized table">
                  <TableHead>
                    <TableRow>
                      <StyledTableCell>
                        Id Control por Estandar Nist
                      </StyledTableCell>
                      <StyledTableCell>ID Estandar Nist</StyledTableCell>
                      <StyledTableCell>
                        Nombre del Estandar Nist
                      </StyledTableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {rowsP.map((row, index) => (
                      <StyledTableRow key={index}>
                        <StyledTableCell component="th" scope="row">
                          {row.idimplementadorporcontrol}
                        </StyledTableCell>
                        <StyledTableCell align="left">
                          {row.idcontrol}
                        </StyledTableCell>
                        <StyledTableCell align="left">
                          {row.nombre_control}
                        </StyledTableCell>
                      </StyledTableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            </Row>
            <Row className="mb-3">
              <Col md={10}>
                <h2 className="subtitulo">Añadir Componente principal</h2>
              </Col>
              <Col md={2}>
                <Button
                  className="botonIngreso"
                  disabled={idrolUser == 7}
                  onClick={() => setModalShowCompP(true)}
                >
                  Añadir
                </Button>{" "}
              </Col>
            </Row>
            <Row className="mb-3">
              <TableContainer
                component={Paper}
                className="table table-bordered"
              >
                <Table className={classes.table} aria-label="customized table">
                  <TableHead>
                    <TableRow>
                      <StyledTableCell align="left">ID</StyledTableCell>
                      <StyledTableCell align="left">Nombre</StyledTableCell>
                      <StyledTableCell align="left">
                        Descripción
                      </StyledTableCell>
                      <StyledTableCell align="left">
                        Responsable TI
                      </StyledTableCell>
                      <StyledTableCell align="left">
                        Responsable Negocio
                      </StyledTableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {rowsc !== null
                      ? rowsc.map((row, index) => {
                        const isItemSelected = isSelectedInfra(row.idactivo);
                        return (
                          <StyledTableRow
                            key={row.idactivo}
                            hover
                            onClick={(event) =>
                              handleClickInfra(event, row.idactivo)
                            }
                            selected={isItemSelected}
                            role="checkbox"
                            tabIndex={-1}
                          >
                            <StyledTableCell component="th" scope="row">
                              {row.idactivo}
                            </StyledTableCell>
                            <StyledTableCell align="left">
                              {row.nombre}
                            </StyledTableCell>
                            <StyledTableCell align="left">
                              {row.descripcion}
                            </StyledTableCell>
                            <StyledTableCell align="left">
                              {row.UsuarioResponsableTI}
                            </StyledTableCell>
                            <StyledTableCell align="left">
                              {row.UsuarioResponsableNegocio}
                            </StyledTableCell>
                          </StyledTableRow>
                        );
                      })
                      : null}
                  </TableBody>
                </Table>
              </TableContainer>
            </Row>
            <hr />
            <Row className="mb-3" style={{ padding: "25px 0px" }}>
              <Col sm={4} xs={1}></Col>
              <Col sm={3} xs={3}>
                {" "}
                <Button
                  type="submit"
                  className="botonPositivo"
                  id="send"
                  disabled={idrolUser == 7}
                >
                  Guardar
                </Button>
              </Col>
              <Col sm={3} xs={3}>
                {" "}
                <Link to="componente-tecnologico">
                  <Button className="botonNegativo" disabled={idrolUser == 7}>
                    Descartar
                  </Button>
                </Link>
              </Col>
            </Row>
          </Form>
        </>
      )}
      {activeTab === 3 && (
        <>
          <div style={{ padding: 24 }}>
            <Row className="mb-3">
              <Col md={5}>
                <label style={{ fontWeight: "bold", fontSize: "1.1rem" }}>
                  Riesgos que mitiga
                </label>
                <Select
                  isDisabled
                  styles={stylesSelect}
                  isMulti
                  value={riesgosMitiga}
                />
              </Col>
              <Col md={7}>
                <label style={{ fontWeight: "bold", fontSize: "1.1rem" }}>
                  Naturaleza
                </label>
                <Select
                  isDisabled
                  placeholder={"Seleccione el tipo de Control"}
                  options={tipoControl}
                  onChange={onChangeTipoControl}
                  styles={stylesSelect}
                  value={valTipoControl}
                />
              </Col>
            </Row>
            <br />
            <h2 style={{ fontSize: "2rem" }}>Análisis de Costos</h2>
            {/* Moneda arriba a la izquierda */}
            <Row className="mb-3">
              <Col md={3}>
                <div style={{ display: "flex", alignItems: "center" }}>
                  <label
                    style={{
                      fontWeight: "bold",
                      fontSize: "1.1rem",
                      marginRight: 10,
                    }}
                  >
                    Moneda
                  </label>
                  <Select
                    options={opcionesMoneda}
                    value={opcionesMoneda.find((opt) => opt.value === moneda)}
                    defaultValue={moneda}
                    onChange={(opt) => setMoneda(opt.value)}
                    styles={stylesSelect}
                    placeholder="Seleccione..."
                  />
                </div>
              </Col>
            </Row>
            <Row>
              {/* Costos directos */}
              <Col md={6}>
                <h5 style={{ fontSize: "1.3rem", marginTop: 24 }}>
                  Costos directos
                </h5>
                <Row className="mb-1">
                  <Col xs={7}></Col>
                  <Col xs={5}>
                    <label style={{ fontWeight: "bold", fontSize: "1.1rem" }}>
                      Periodicidad
                    </label>
                  </Col>
                </Row>
                <Row className="mb-3 align-items-center">
                  <Col xs={7} className="d-flex align-items-center">
                    <label
                      style={{
                        minWidth: 130,
                        fontSize: "1.1rem",
                        marginRight: 10,
                      }}
                    >
                      Licencias
                    </label>
                    <input
                      type="number"
                      className="form-control"
                      value={licencias}
                      placeholder="$$"
                      style={{ fontSize: "1.1rem", width: 250 }}
                      onChange={(e) => {
                        const valor = e.target.value.replace(/\D/g, "");
                        setLicencias(valor);
                      }}
                    />
                  </Col>
                  <Col xs={5}>
                    <Select
                      options={opcionesPeriodicidad}
                      value={opcionesPeriodicidad.find(
                        (opt) => opt.value === periodLicencias
                      )}
                      onChange={(opt) => setPeriodLicencias(opt.value)}
                      styles={stylesSelect}
                      placeholder="Seleccione..."
                    />
                  </Col>
                </Row>
                <Row className="mb-3 align-items-center">
                  <Col xs={7} className="d-flex align-items-center">
                    <label
                      style={{
                        minWidth: 130,
                        fontSize: "1.1rem",
                        marginRight: 10,
                      }}
                    >
                      Implementación
                    </label>
                    <input
                      type="number"
                      className="form-control"
                      value={implementacion}
                      placeholder="$$"
                      style={{ fontSize: "1.1rem", width: 250 }}
                      onChange={(e) => {
                        const valor = e.target.value.replace(/\D/g, "");
                        setImplementacion(valor);
                      }}
                    />
                  </Col>
                  <Col xs={5}>
                    <Select
                      options={opcionesPeriodicidad}
                      value={opcionesPeriodicidad.find(
                        (opt) => opt.value === periodImplementacion
                      )}
                      onChange={(opt) => setPeriodImplementacion(opt.value)}
                      styles={stylesSelect}
                      placeholder="Seleccione..."
                    />
                  </Col>
                </Row>
              </Col>
              {/* Costos operativos */}
              <Col md={6}>
                <h5 style={{ fontSize: "1.3rem", marginTop: 24 }}>
                  Costos operativos
                </h5>
                <Row className="mb-1">
                  <Col xs={7}></Col>
                  <Col xs={5}>
                    <label style={{ fontWeight: "bold", fontSize: "1.1rem" }}>
                      Periodicidad
                    </label>
                  </Col>
                </Row>
                <Row className="mb-3 align-items-center">
                  <Col xs={7} className="d-flex align-items-center">
                    <label
                      style={{
                        minWidth: 130,
                        fontSize: "1.1rem",
                        marginRight: 10,
                      }}
                    >
                      Mantenimiento
                    </label>
                    <input
                      type="number"
                      className="form-control"
                      value={mantenimiento}
                      placeholder="$$"
                      style={{ fontSize: "1.1rem", width: 250 }}
                      onChange={(e) => setMantenimiento(e.target.value)}
                    />
                  </Col>
                  <Col xs={5}>
                    <Select
                      options={opcionesPeriodicidad}
                      value={opcionesPeriodicidad.find(
                        (opt) => opt.value === periodMantenimiento
                      )}
                      onChange={(opt) => setPeriodMantenimiento(opt.value)}
                      styles={stylesSelect}
                      placeholder="Seleccione..."
                    />
                  </Col>
                </Row>
                <Row className="mb-3 align-items-center">
                  <Col xs={7} className="d-flex align-items-center">
                    <label
                      style={{
                        minWidth: 130,
                        fontSize: "1.1rem",
                        marginRight: 10,
                      }}
                    >
                      Actualización
                    </label>
                    <input
                      type="number"
                      className="form-control"
                      value={actualizacion}
                      placeholder="$$"
                      style={{ fontSize: "1.1rem", width: 250 }}
                      onChange={(e) => setActualizacion(e.target.value)}
                    />
                  </Col>
                  <Col xs={5}>
                    <Select
                      options={opcionesPeriodicidad}
                      value={opcionesPeriodicidad.find(
                        (opt) => opt.value === periodActualizacion
                      )}
                      onChange={(opt) => setPeriodActualizacion(opt.value)}
                      styles={stylesSelect}
                      placeholder="Seleccione..."
                    />
                  </Col>
                </Row>
                <Row className="mb-3 align-items-center">
                  <Col xs={7} className="d-flex align-items-center">
                    <label
                      style={{
                        minWidth: 130,
                        fontSize: "1.1rem",
                        marginRight: 10,
                      }}
                    >
                      Admón y soporte
                    </label>
                    <input
                      type="number"
                      className="form-control"
                      value={soporte}
                      placeholder="$$"
                      style={{ fontSize: "1.1rem", width: 250 }}
                      onChange={(e) => setSoporte(e.target.value)}
                    />
                  </Col>
                  <Col xs={5}>
                    <Select
                      options={opcionesPeriodicidad}
                      value={opcionesPeriodicidad.find(
                        (opt) => opt.value === periodSoporte
                      )}
                      onChange={(opt) => setPeriodSoporte(opt.value)}
                      styles={stylesSelect}
                      placeholder="Seleccione..."
                    />
                  </Col>
                </Row>
                <Row className="mb-3 align-items-center">
                  <Col xs={7} className="d-flex align-items-center">
                    <label
                      style={{
                        minWidth: 130,
                        fontSize: "1.1rem",
                        marginRight: 10,
                      }}
                    >
                      Consultoría
                    </label>
                    <input
                      type="number"
                      className="form-control"
                      value={consultoria}
                      placeholder="$$"
                      style={{ fontSize: "1.1rem", width: 250 }}
                      onChange={(e) => setConsultoria(e.target.value)}
                    />
                  </Col>
                  <Col xs={5}>
                    <Select
                      options={opcionesPeriodicidad}
                      value={opcionesPeriodicidad.find(
                        (opt) => opt.value === periodConsultoria
                      )}
                      onChange={(opt) => setPeriodConsultoria(opt.value)}
                      styles={stylesSelect}
                      placeholder="Seleccione..."
                    />
                  </Col>
                </Row>
                <Row className="mb-3 align-items-center">
                  <Col xs={7} className="d-flex align-items-center">
                    <label
                      style={{
                        minWidth: 130,
                        fontSize: "1.1rem",
                        marginRight: 10,
                      }}
                    >
                      Personal <span style={{ color: "red" }}>(FTEs)</span>
                    </label>
                    <input
                      type="number"
                      className="form-control"
                      value={personal}
                      placeholder="$$"
                      style={{ fontSize: "1.1rem", width: 250 }}
                      onChange={(e) => setPersonal(e.target.value)}
                    />
                  </Col>
                  <Col xs={5}>
                    <Select
                      options={opcionesPeriodicidad}
                      value={opcionesPeriodicidad.find(
                        (opt) => opt.value === periodPersonal
                      )}
                      onChange={(opt) => setPeriodPersonal(opt.value)}
                      styles={stylesSelect}
                      placeholder="Seleccione..."
                    />
                  </Col>
                </Row>
                {/* Costos totales anual abajo a la derecha */}
                <Row>
                  <Col md={8}></Col>
                  <Col md={4} style={{ textAlign: "right" }}>
                    <label
                      style={{
                        fontWeight: "bold",
                        fontSize: "1.1rem",
                        display: "block",
                      }}
                    >
                      Costos totales (anual)
                    </label>
                    <input
                      type="number"
                      className="form-control"
                      value={costosTotales}
                      disabled
                      placeholder="$$"
                      style={{
                        fontSize: "1.1rem",
                        width: 180,
                        display: "inline-block",
                      }}
                    />
                  </Col>
                </Row>
                <Row style={{ marginTop: 0 }}>
                  <Col
                    xs={12}
                    style={{ fontSize: 16, textAlign: "right", marginTop: 8 }}
                  >
                    El costo total es el costo consolidado de todas las
                    compañías que lo usan
                  </Col>
                </Row>
              </Col>
            </Row>
            <br />
            <div>
              <h2 style={{ fontSize: "2rem" }}>Análisis de Beneficio</h2>
              <Row>
                <Col sm={6} xs={12}>
                  <label>Amenazas a analizar</label>
                  <Select
                    isMulti
                    placeholder="Seleccione las amenazas"
                    styles={stylesSelect}
                    options={valAmenaza}
                    value={selectedAmenazas}
                    onChange={handleChangeAmenazas}
                  />
                </Col>
                <Col sm={3} xs={12}>
                  <label>Exposición</label>
                  <input
                    type="text"
                    className="form-control"
                    value={exposicion}
                    disabled
                    placeholder="Exposición"
                    style={{ fontSize: "1.1rem", width: "100%" }}
                  />
                </Col>
              </Row>
            </div>
            <br />
            <div>
              <h2 style={{ fontSize: "2rem" }}>Costo-Beneficio (ROSI)</h2>
              <Row>
                {/*Gráfica velocímetro */}
                <GraficaCostos value={rosi} />
              </Row>
            </div>
          </div>
          <Row className="mb-3">
            <Col sm={5} xs={1}></Col>
            <Col sm={3} xs={3}>
              {" "}
              <Button
                type="submit"
                className="botonPositivo"
                onClick={() => handleSaveCostoBeneficio()}
                id="send"
                disabled={idrolUser != 1}
              >
                Guardar
              </Button>
            </Col>
          </Row>
        </>
      )}
    </>
  );
}
export default EditarImplementadores;
